export const ontarioInPageNavigationHeadingLevels = ['h2', 'h3', 'h4'] as const;
export type OntarioInPageNavigationHeadingLevel = (typeof ontarioInPageNavigationHeadingLevels)[number];
